import { Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/useAuth';
import { SettingsProvider } from './settings/SettingsContext';
import { Layout } from './screens/Layout';
import { Daily } from './screens/Daily';
import { Levels } from './screens/Levels';
import { Leaderboard } from './screens/Leaderboard';
import { Stats } from './screens/Stats';
import { Settings } from './screens/Settings';
import { SignIn } from './screens/SignIn';

export default function App() {
  return (
    <AuthProvider>
      <AuthedApp />
    </AuthProvider>
  );
}

function AuthedApp() {
  const { user, loading, login } = useAuth();

  if (loading) return <main className="notice">Loading…</main>;
  if (!user) return <SignIn onSignIn={login} />;

  return (
    <SettingsProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Daily />} />
          <Route path="/levels" element={<Levels />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </SettingsProvider>
  );
}
